import personaConfirmationDictionary from '@widgets/persona-confirmation/i18n/ru/persona-confirmation.dic.json';

export const personaConfirmation = {
  PERSONA_CONFIRMATION: personaConfirmationDictionary,
};

export const personaConfirmationNamespaces = Object.keys(personaConfirmation);
